import React, { Component } from 'react';
import ListOfTags from '../../components/tags/ListOfTags';
import OrganisationName from '../../components/shared/OrganisationName';
import SetTitle from '../../components/shared/SetTitle';
import PopupBox from '../../components/shared/PopupBox';

class TagsIndex extends Component {
  render() {
    const { match: { params } } = this.props;

    return (
      <div>
        <SetTitle title={"Tags"} />
        <PopupBox />


        <h2 className="page-title">People Tags</h2>
        <OrganisationName />

        <div>
          <ListOfTags id={params.id} />
        </div>
      </div>
    );
  }
}

export default TagsIndex;
